import { Component, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

import {
    WorkshopCardRatingStoreSelectors,
} from 'app/root-store/workshop-store/cardrating-store';
import { RootStoreState } from 'app/root-store';
import { WorkshopTimerStoreActions } from 'app/root-store/workshop-store/timer-store';
import { WorkshopCanvasStoreActions, WorkshopCanvasStoreSelectors } from 'app/root-store/workshop-store/canvas-store';
import { SessionCategoryModel } from '@bsuccess/models/session/session-category';
import { LoginStoreSelectors } from 'app/root-store/login-store';
import { locale as english } from '../../../../../../i18n/workshop/canvas/animator/board/dialogs/evaluation-points/en';
import { locale as frensh } from '../../../../../../i18n/workshop/canvas/animator/board/dialogs/evaluation-points/fr';
import { locale as arabic } from '../../../../../../i18n/workshop/canvas/animator/board/dialogs/evaluation-points/ar';
import { Activity } from '@bsuccess/models/activities/activity.model';
import { WorkshopActivityStoreActions, WorkshopActivityStoreSelectors } from 'app/root-store/workshop-store/activity-store';

@Component({
    selector: 'board-canvas-evaluation-points',
    templateUrl: './evaluation-points.component.html',
    styleUrls: ['./evaluation-points.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class BoardCanvasEvaluationPointsComponent implements OnInit {
    allComplete  :boolean =false;
    categories$: Observable<SessionCategoryModel[]>;
    categories: SessionCategoryModel[] = [];
    allCategoriesChecked$: Observable<boolean>;
    allCategoriesChecked: boolean;
    isAnyCategoryChecked: boolean;
    currentActivity$: Observable<Activity>;
    currentActivity: Activity;
    max$: Observable<number>;
    max = 30;

    maxPerCard$: Observable<number>;
    maxPerCard = 30;
    constructor(
        public matDialogRef: MatDialogRef<BoardCanvasEvaluationPointsComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _store: Store<RootStoreState.State>,
        private translationLoaderService: FuseTranslationLoaderService,
        public translateService: TranslateService,
    ) {
        this.translationLoaderService.loadTranslations(english, frensh, arabic);
    }

    ngOnInit(): void {
        this.max$ = this._store.pipe(
            select(WorkshopCardRatingStoreSelectors.selectBalance)
        );
        this.max$.subscribe(max => {
            this.max = max;
        });

        this.allCategoriesChecked$ = this._store.pipe(
            select(WorkshopCanvasStoreSelectors.selectAllCategoriesChecked)
        );

        this.maxPerCard$ = this._store.pipe(
            select(WorkshopCardRatingStoreSelectors.selectMaxPerCard)
        );
        this.maxPerCard$.subscribe(maxPerCard => {
            this.maxPerCard = maxPerCard;
        });

        this._store.dispatch(
            WorkshopCanvasStoreActions.updateAllCategoriesChecked({
                checked: true
            })
        );
        this.categories$ = this._store.pipe(
            select(LoginStoreSelectors.selectSessionCategories)
        );
        this.categories$.subscribe(categories => {
            this.categories = categories;
            if (this.categories.filter(_ => _.checked).length === 0) {
                this.isAnyCategoryChecked = false;
            } else {
                this.isAnyCategoryChecked = true;
            }
        });
        this.currentActivity$ = this._store.pipe(
            select(WorkshopActivityStoreSelectors.selectCurrentActivity)
        );

        this.currentActivity$.subscribe(_ => {
            this.currentActivity = _;
        });

        this.allCategoriesChecked$.subscribe(checked => {
            this.allCategoriesChecked = checked;
        });
        this.allCategoriesChecked =false;
    }

    someComplete(): boolean {
        if (this.categories == null) {
          return false;
        }
        return this.categories.filter(t => t.checked).length > 0 && !this.allComplete; 
    }
    save(): void {
        this._store.dispatch(
            WorkshopTimerStoreActions.start({
                value: 9999,
                exercise: 'evaluation/canvas',
                balance: this.max,
                maxPerCard: this.maxPerCard
            })
        );

        if (this.currentActivity.brainstormStarted) {
            this._store.dispatch(WorkshopActivityStoreActions.updateStartedBrainstorm({
                activity: this.currentActivity,
                brainstormStarted: false
            }));
        }
        this._store.dispatch(WorkshopActivityStoreActions.updateStartedEvaluation({
            activity: this.currentActivity,
            evaluationStarted: true
        }));

        this._store.dispatch(
            WorkshopCanvasStoreActions.updateTimer({
                timer: {
                    balance: this.max,
                    maxPerCard: this.maxPerCard,
                    timerType: 'evaluation',
                    categories: [],
                    timer: true
                }
            })
        );

        this._store.dispatch(
            WorkshopCanvasStoreActions.updateWorkFlowStep({
                step: 3
            })
        );
    }

    updateAllSelectedCategories(allCategoriesChecked,completed): void {
        this._store.dispatch(
            WorkshopCanvasStoreActions.updateAllCategoriesChecked({
                checked: this.allCategoriesChecked
            })
        );
        this.allComplete = completed;
        if (this.categories == null) {
          return;
        }
        this.categories.forEach(t => (t.checked = completed)); 
    }
}
